import { getAPIPath, requestGooseAPI } from '../shared/request'
import { OrderValidationResponseClientDto } from '../types/api'
import { CLIENT_ORDER_VALIDATION_PATH, CLIENT_ORDER_VALIDATION_ID_PATH } from '../types/constants'

export const ClientLocationOrderValidationService = {
  userValidation: (locationName: string, lupId: string, includes?: string[]) =>
    requestGooseAPI<OrderValidationResponseClientDto>({
      url: getAPIPath(CLIENT_ORDER_VALIDATION_PATH, { locationId: locationName, lupId }),
      method: 'GET',
      params: {
        includes: includes || [],
      },
    }),

  userOrderValidation: (locationName: string, lupId: string, orderId: string, includes?: string[]) => {
    return requestGooseAPI<OrderValidationResponseClientDto>({
      url: getAPIPath(CLIENT_ORDER_VALIDATION_ID_PATH, { locationId: locationName, lupId, id: orderId }),
      method: 'GET',
      params: {
        includes: includes || [],
      },
    })
  },
}
